import { FetchContext } from '../fetch-context';
import { TimeZone } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getTimeZones: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<TimeZone[]> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/time-zones`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<TimeZone[]>(fetchContext.errorStore, response, 'get time zones'));
